import React from 'react';
import Container from '@material-ui/core/Container';
import Footer from './_footer';
import FooterNavigate from './_navigate';
import PartnerSection from './_partners';
import Newsletter from './_newsletter';

const FooterSection = () => {

  return (
    <>
      <Container
        component="footer"
        disableGutters
        maxWidth="xl"
      >
        <PartnerSection />
        <FooterNavigate />
        <Newsletter />
        <Footer />
      </Container>
    </>
  );
}

export default FooterSection;
